<template>
  <transition name="slide-in-left"> </transition>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      place: '',
      alwaysOpen: false,
      content: {
        width: 0,
        height: 0,
      },
      options: null,
    }
  },
  computed: {
    /*    model() {
      return this.$store.getters['jobsmap/data']
    },
    showFilters() {
      return this.$store.getters['jobsmap/getShowFilters']
    },
    categories() {
      return this.$store.getters['jobsmap/getCategories']
    },
    categoriesFiltered() {
      return this.$store.getters['jobsmap/getCategoriesFiltered']
    },
    activeTypeFilter() {
      return this.$store.getters['jobsmap/getActiveTypeFilter']
    }*/
  },
  watch: {},
  mounted() {
    //this.$store.dispatch('jobsmap/getCategories', {})
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.content.width = window.innerWidth
      this.content.height = window.innerHeight - 110
    },
    /*
      Toggle the show and hide of filter sidebar.
      */
    toggleShowFilters() {
      this.$store.dispatch('jobsmap/toggleShowFilters', {
        showFilters: !this.showFilters,
      })
    },
    setActiveTypeFilter(filter) {
      this.$store.dispatch('jobsmap/updateActiveTypeFilter', filter)
      this.$store.dispatch('jobsmap/getMarkers', {})
    },
    setFilter() {
      this.$nextTick(() => {
        this.$store.dispatch('jobsmap/getMarkers', {})
      })
    },
  },
}
</script>
